module.exports = __webpack_public_path__ + "img/fission-func3.b306ff27.jpg";